var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.414 16.6c-1.08-.04-4.14-.463-7.346-3.668C1.863 9.727 1.44 6.667 1.4 5.586 1.34 3.939 2.602 2.339 4.06 1.714a1.1 1.1 0 0 1 1.084.12c1.2.874 2.028 2.197 2.739 3.237a1.13 1.13 0 0 1-.192 1.49L6.226 7.648a.36.36 0 0 0-.106.462c.332.602.921 1.499 1.596 2.174s1.615 1.303 2.259 1.672a.363.363 0 0 0 .483-.121l.953-1.45a1.127 1.127 0 0 1 1.542-.249c1.055.73 2.286 1.545 3.188 2.699a1.1 1.1 0 0 1 .142 1.113c-.628 1.465-2.217 2.712-3.869 2.652",
  clipRule: "evenodd"
})));
export default SvgPhone;